import React, { useState } from "react";
import { ICouncilMemberData } from "../../exports/interfaces";
import { formatUrl } from "../../exports/functions";
import PopUpDialog from "../PopUpDialog";
import DynamicToolTip from "../DynamicToolTip";
import { Fade } from "react-awesome-reveal";

const CouncilMember = (props: { councilMemberData: ICouncilMemberData[] }) => {
  const [open, setOpen] = useState(false);
  const [selectedMember, setSelectedMember] =
    useState<ICouncilMemberData | null>(null);

  const handleClickOpen = (member: ICouncilMemberData) => {
    setSelectedMember(member);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMember(null);
  };

  const groupedData = props.councilMemberData.reduce(
    (acc, item) => {
      const category = item.category;

      const existingCategory = acc.find(
        (group) =>
          group.category.replace(/\s+/g, "").toLowerCase() ===
          category.replace(/\s+/g, "").toLowerCase(),
      );

      if (existingCategory) {
        existingCategory.data.push(item);
      } else {
        acc.push({ category, data: [item] });
      }

      return acc;
    },
    [] as { category: string; data: typeof props.councilMemberData }[],
  );

  return (
    <>
      {groupedData?.map((group, index) => (
        <section
          className="volunteers-one"
          key={index}
          style={{
            padding:
              index === 0
                ? "90px 0px 0px 0px"
                : groupedData.length === index + 1
                  ? "54px 0px"
                  : "54px 0px 0px 0px",
          }}
        >
          <div className="container">
            <div className="section-title text-center">
              <h2 className="section-title__title">{group.category}</h2>
            </div>
            <div className="row" style={{ justifyContent: "center" }}>
              {group.data.map((member, index) => (
                <div className="col-5th custom-margin-bottom" key={member.id}>
                  <Fade
                    key={index}
                    cascade
                    damping={0.2}
                    triggerOnce={true}
                    delay={index * 200}
                  >
                    <div
                      className="volunteers-one__single"
                      onClick={() => handleClickOpen(member)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="volunteers-one__img">
                        <img
                          src={
                            member.image[0]?.media?.url &&
                            `${process.env.REACT_APP_strapiUrl}${member.image[0].media.url}`
                          }
                          alt="council-image"
                          className="row-image"
                          style={{
                            objectFit: member.name
                              .toUpperCase()
                              .includes("JERIN")
                              ? "inherit"
                              : "cover",
                            width: "100%",
                            objectPosition: "top",
                          }}
                        />
                        <div className="volunteers-one__social">
                          <DynamicToolTip title="TwitterX">
                            <a
                              href={formatUrl(member.twitter)}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <i className="fab fa-twitter"></i>
                            </a>
                          </DynamicToolTip>
                          <DynamicToolTip title="Facebook">
                            <a
                              href={formatUrl(member.facebook)}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <i className="fab fa-facebook"></i>
                            </a>
                          </DynamicToolTip>
                          <DynamicToolTip title="Instagram">
                            <a
                              href={formatUrl(member.instagram)}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <i className="fab fa-instagram"></i>
                            </a>
                          </DynamicToolTip>
                        </div>
                      </div>
                      <div className="volunteers-one__content row-content">
                        <h4 className="volunteers-one__name custom-grid-font-size text-truncate">
                          <DynamicToolTip title={member.name}>
                            {member.name}
                          </DynamicToolTip>
                        </h4>
                        <p
                          className="volunteers-one__title text-truncate"
                          style={{ textTransform: "capitalize" }}
                        >
                          <DynamicToolTip
                            title={(member.sub_category
                              ? member.sub_category
                              : member.category
                            )
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                          >
                            {(member.sub_category
                              ? member.sub_category
                              : member.category
                            )
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                          </DynamicToolTip>
                        </p>
                      </div>
                    </div>
                  </Fade>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
      <PopUpDialog open={open} onClose={handleClose} member={selectedMember} />
    </>
  );
};

export default CouncilMember;
